import React from 'react'
import ReactDOM from 'react-dom'
import { HashRouter } from 'react-router-dom'
import { Provider } from 'react-redux'
import ReactGA from 'react-ga'
import * as Sentry from '@sentry/browser'
import { createBrowserHistory } from 'history'
import rootStore from './store/rootStore'
import { cookUnityUuid } from './utils/browserCookies'
import { unregister } from './registerServiceWorker'
import App from './App'

ReactGA.initialize('UA-46494018-1')
Sentry.init({
  dsn: 'https://a72ca73c2074488bbe5aa2aaa79c64a6@sentry.io/1234987'
})

Sentry.configureScope(scope => {
  scope.setUser({ user_anonymous_id: cookUnityUuid })
})

const history = createBrowserHistory()

history.listen(location => {
  ReactGA.pageview(location.pathname + location.hash)
})

ReactDOM.render(
  <Provider store={rootStore}>
    <HashRouter history={history}>
      <App />
    </HashRouter>
  </Provider>,
  document.getElementById('root')
)

unregister()



// WEBPACK FOOTER //
// ./src/index.js